import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { validClassNameColumn } from '../../utils/commonUtils';
import Wrapper from './style';

const Index = (props) => {
  const { title, description, isValid = true } = props;

  return (
    <Wrapper>
      <Row gutter={[24, 12]}>
        <Col span={4}>
          {isValid ? (
            <CheckCircleOutlined />
          ) : (
            <Tooltip title="Data invalid">
              <WarningOutlined />
            </Tooltip>
          )}
        </Col>
        <Col>
          <div
            className={validClassNameColumn({
              className: 'font-paragraph_medium',
              isValid,
            })}
          >
            {title}
          </div>
          <div
            className={validClassNameColumn({
              className: 'font-paragraph',
              isValid,
            })}
          >
            {description}
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default Index;
